import { styled } from '../../styles';
import { Alert } from '../Alert';

export const AlertStyled = styled(Alert)(() => ({
  maxWidth: '320px!important',
  '@media (max-width: 768px)': {
    maxWidth: '80vw!important',
    float: 'right' as any,
  },
}));
